export default {
    getFavourites(state) {
        return state.favouritesArr;
    }
};
